<div class="main-container" (click)="showLsParticipants($event)">
  <div class="avatars-container">
    <ng-container *ngFor="let initials of getParticipantInitials(); let i = index">
      <div class="avatar" [ngStyle]="{ 'z-index': learnspace.Participants.length - i }">{{ initials }}</div>
    </ng-container>
  </div>
  <div class="names text-truncate programs-body-1">{{ getParticipantNames() }}</div>
</div>